import { render, staticRenderFns } from "./UserAppointment.vue?vue&type=template&id=27b22ad2&scoped=true&"
import script from "./UserAppointment.vue?vue&type=script&lang=js&"
export * from "./UserAppointment.vue?vue&type=script&lang=js&"
import style0 from "./UserAppointment.vue?vue&type=style&index=0&id=27b22ad2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b22ad2",
  null
  
)

export default component.exports